import { InitialConstraints } from 'app/common/ui/data-grid';

import {
  TEntityGridConstraintsState,
  TEntityGridRowModelNameTypes,
} from '../../core';

type DataGridFilters = InitialConstraints['filter'];
type EntityGridFilters = TEntityGridConstraintsState['filter'];

type DataGridSort = InitialConstraints['sort'];
type EntityGridSort = TEntityGridConstraintsState['sorting'];

type DataGridPaging = InitialConstraints['pagination'];
type EntityGridPaging = TEntityGridConstraintsState['pageInfo'];

type PrepareDataGridConstraintsParams = {
  constraints: InitialConstraints;
  rowModelType: TEntityGridRowModelNameTypes;
  recordsLimit: number;
};
export function prepareDataGridConstraints({
  constraints,
  rowModelType,
  recordsLimit,
}: PrepareDataGridConstraintsParams): TEntityGridConstraintsState {
  const filter = prepareFilterState(constraints.filter);
  const sorting = prepareSortState(constraints.sort);
  const pageInfo = preparePagingState({
    pagination: constraints.pagination,
    rowModelType,
    recordsLimit,
  });

  return {
    filter,
    sorting,
    pageInfo,
  };
}

function prepareFilterState(filters: DataGridFilters): EntityGridFilters {
  if (!filters) return {};

  const result: EntityGridFilters = {};

  for (const model of Object.values(filters)) {
    result[model.filterName] = model.value;
  }

  return result;
}
type EntityGridSortDirections =
  NonNullable<EntityGridSort>[number]['direction'];
type DataGridSortDirections = NonNullable<DataGridSort>[number]['sort'];
const sortDirections: Record<DataGridSortDirections, EntityGridSortDirections> =
  {
    asc: 'ascend',
    desc: 'descend',
  };

function prepareSortState(sort: DataGridSort): EntityGridSort {
  if (!sort) return [];

  const result: EntityGridSort = sort.map((model) => ({
    name: model.colId,
    direction: sortDirections[model.sort],
  }));

  return result;
}

type PreparePagingStateParams = {
  pagination: DataGridPaging;
  rowModelType: TEntityGridRowModelNameTypes;
  recordsLimit: number;
};
function preparePagingState({
  pagination,
  rowModelType,
  recordsLimit,
}: PreparePagingStateParams): EntityGridPaging {
  const size = rowModelType === 'largeList' ? recordsLimit : 40;

  if (!pagination) return { page: 1, size };

  const result: EntityGridPaging = {
    page: pagination.page || 1,
    size:
      rowModelType === 'largeList' ? recordsLimit : pagination.pageSize || 40,
  };

  return result;
}
